module.exports = __webpack_public_path__ + "static/media/Chuva.619686f8.jpg";